var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMely(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 663.29 325.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n                    .cls-1,\n                    .cls-3 {\n                      fill: #847770;\n                    }\n\n                    .cls-2,\n                    .cls-4 {\n                      fill: #ff6b00;\n                    }\n\n                    .cls-3,\n                    .cls-4 {\n                      fill-rule: evenodd;\n                    }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.76,424.25V390.07H132.9q8.32,0,12.1,2.55t3.78,8.09q0,5.51-3.83,8.08t-12,2.59h-3.59v12.87Zm9.55-19.82h3.63c2.27,0,3.84-.28,4.71-.85a3.2,3.2,0,0,0,1.32-2.91,3.5,3.5,0,0,0-1.32-3.1c-.87-.61-2.44-.91-4.71-.91h-3.63Z",
    transform: "translate(-64.76 -148.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145,424.25l11.48-34.18h10.62l11.39,34.18H168.4l-2-6.46H155l-2.15,6.46Zm12.29-13.64h6.94l-3.39-10.93Z",
    transform: "translate(-64.76 -148.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.8,413.48a15,15,0,0,1-4.86,8.66,14.21,14.21,0,0,1-9.31,2.92q-7.59,0-11.85-4.65t-4.26-12.93a21.56,21.56,0,0,1,1-6.88A17,17,0,0,1,182.7,395a14.73,14.73,0,0,1,5.28-4.11,15.73,15.73,0,0,1,6.7-1.4,12.9,12.9,0,0,1,9,3.26,15.31,15.31,0,0,1,4.61,9.07l-9,.67a8.63,8.63,0,0,0-1.62-4.4,4.22,4.22,0,0,0-3.37-1.33,4.65,4.65,0,0,0-4.38,2.55c-.94,1.7-1.4,4.36-1.4,8s.53,6.32,1.59,8.15a5.13,5.13,0,0,0,4.74,2.73,6,6,0,0,0,4.25-1.57,8.5,8.5,0,0,0,2.34-4.51Z",
    transform: "translate(-64.76 -148.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M212.06,424.25V390.07h9.64v13.69l10.23-13.69h9.15l-8.25,11,10.59,23.19H232.69l-6.37-14.58-4.62,6.06v8.52Z",
    transform: "translate(-64.76 -148.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.86,424.25l11.48-34.18H263l11.39,34.18H264.23l-2-6.46H250.85l-2.15,6.46Zm12.29-13.64h6.94l-3.39-10.93Z",
    transform: "translate(-64.76 -148.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.84,421a10.79,10.79,0,0,1-4.25,3.07,15.75,15.75,0,0,1-5.89,1q-7.08,0-11.19-4.67t-4.12-12.7q0-8.53,4.29-13.39t11.87-4.85a15.72,15.72,0,0,1,9.89,3,14.24,14.24,0,0,1,5.13,8.55l-9.33,1.53a7.65,7.65,0,0,0-1.75-4.64,5,5,0,0,0-3.89-1.64A4.86,4.86,0,0,0,286,399q-1.47,2.67-1.47,8.28,0,5.81,1.43,8.38a4.86,4.86,0,0,0,4.6,2.57,6,6,0,0,0,4-1.33,4.9,4.9,0,0,0,1.76-3.53h-5.57v-6h14.76v16.9h-3.06Z",
    transform: "translate(-64.76 -148.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.81,424.25V390.07h9.65v34.18Z",
    transform: "translate(-64.76 -148.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M326.51,424.25V390.07h9l12.2,17.45V390.07h7.44v34.18h-7.44L334,405.46v18.79Z",
    transform: "translate(-64.76 -148.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.65,421a10.71,10.71,0,0,1-4.25,3.07,15.71,15.71,0,0,1-5.89,1c-4.72,0-8.44-1.56-11.19-4.67s-4.12-7.34-4.12-12.7q0-8.53,4.3-13.39t11.86-4.85a15.7,15.7,0,0,1,9.89,3,14.25,14.25,0,0,1,5.14,8.55l-9.33,1.53a7.77,7.77,0,0,0-1.75-4.64,5.05,5.05,0,0,0-3.9-1.64,4.86,4.86,0,0,0-4.56,2.67q-1.46,2.67-1.46,8.28,0,5.81,1.42,8.38a4.87,4.87,0,0,0,4.6,2.57,6,6,0,0,0,4-1.33,4.93,4.93,0,0,0,1.75-3.53h-5.56v-6h14.76v16.9h-3.07Z",
    transform: "translate(-64.76 -148.86)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M554.77,188.89,473,358.79q-12.5,26-22.58,31.47c-6.68,3.67-15,5.53-25,5.53H396.1l6.64-22.88c11,0,17.92-.56,20.89-1.61s5.2-4.27,6.73-9.54,3.52-32.92,5.94-82.81l4.33-90h42l-8.4,89.54,39.72-89.54ZM385.45,359.66H343.58l61.13-210.8h41.86ZM320.16,261.8l11.37-39.19c1.62-5.58.07-8.39-4.6-8.38s-7.94,2.81-9.55,8.38L306,261.81Zm34.44,25.59h-56L287.12,327c-1.67,5.78-.14,8.64,4.62,8.64s7.86-2.87,9.53-8.64l9.9-34.13H353L343,327.5Q333,362,283.81,362.09q-48.72,0-38.29-36l29.66-102.29q10.45-36.06,59.19-36.05,49.15,0,39.11,34.58Zm-128.72,72.3H184.62l34.32-118.34L160.48,359.7H128.56l6.66-118.34L100.9,359.71H64.76l61.13-210.8h59.53L174.89,258.27,225,148.9h62Z",
    transform: "translate(-64.76 -148.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M559.81,350.45l-4.21-2-57.15,31.41,4.11,2.25Zm2.67,1.28h0l-57.42,31.72Z",
    transform: "translate(-64.76 -148.86)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "511.43 79.89 495.29 74.3 488.37 89.6 511.43 79.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "551.96 62.8 534.6 56.5 505.87 68.19 523.73 74.7 551.96 62.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "524.03 55.44 508.82 50.2 502.42 64.36 524.03 55.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "568.19 99.53 552.01 93.93 488.18 122.43 505.38 130.19 568.19 99.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "604.66 81.73 590.69 76.66 563 89.02 578.3 94.6 604.66 81.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "466.43 149.19 462.28 147.33 460.03 152.32 466.43 149.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "458.65 155.37 608.49 83.11 662.37 102.53 423.1 234.05 458.65 155.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "530.84 55.23 507.53 47.2 497.73 68.9 530.84 55.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M598.55,380.73l-34.42,21.84.86-52.23,35.4-19.56ZM603,329.34l-1,25.79.83-25.71Z",
    transform: "translate(-64.76 -148.86)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "662.93 110.39 630.55 129.48 633.04 128.01 632.64 168.11 630.23 169.52 663.29 150.27 662.93 110.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "443.08 233.05 497.7 202.88 496.97 252.71 443.08 233.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "496.93 255.26 381.94 325.13 417.05 247.43 440.29 234.59 496.93 255.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "630.55 129.48 597.12 147.95 630.31 159.51 630.55 129.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "594.29 149.51 538.23 180.49 537.26 206.27 536.49 230.16 630.23 169.52 630.29 162.05 594.29 149.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M114.09,430.44a5.43,5.43,0,0,1-1.15,3.28H389.83l6.44-3.28Z",
    transform: "translate(-64.76 -148.86)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "555.37 63.98 587.26 75.45 471.32 127.32 486.92 92.83 555.37 63.98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMely);
export default __webpack_public_path__ + "static/media/logo-mely.6e3208ff2a2213d30233b9243cb3d3bb.svg";
export { ForwardRef as ReactComponent };